import React, {Component} from 'react'
import {compose} from 'recompose'
import withSelectFetch from './withSelectFetch'
import withSpinning from '../HOC/withSpinning'
import withSort from '../HOC/withSort'
import CustomSelect from './CustomSelect'

class UOM extends Component {
  render() {
    return (
      <CustomSelect
        data-testid="uom"
        placeholder={'Unit of Measure'}
        {...this.props}
      />
    )
  }
}

export default compose(
  withSelectFetch({dropdown: 'general', name: 'uom'}),
  withSpinning,
  withSort,
)(UOM)
